import Cookies from 'js-cookie'
function getDdsUUID(){
	try {
		var currentDdsUUIDCookieValue = Cookies.get('ddsUUID');
		if(!currentDdsUUIDCookieValue){
			var domain = window.location.host;
			if(domain != 'localhost'){
				domain = '.' + domain;
			}
			currentDdsUUIDCookieValue = getUUID();
			Cookies.set('ddsUUID', currentDdsUUIDCookieValue, {
				expires: 30,
				path: '/',
				domain: domain,
			});
		}
		return currentDdsUUIDCookieValue;
	}catch(e){
		console.log(e);
	}
}

function getUUID(){
	let time = new Date().getTime();
	if (typeof performance !== 'undefined' && typeof performance.now === 'function'){
		time += performance.now();
	}
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		let random = (time + Math.random() * 16) % 16 | 0;
		time = Math.floor(time / 16);
		return (c === 'x' ? random : (random & 0x3 | 0x8)).toString(16);
	});
}

export {
	getDdsUUID
}